"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.templates = exports.conditions = exports.Aquarius = exports.Keeper = exports.Logger = exports.DID = exports.Config = exports.Account = exports.Ocean = void 0;
var Config_1 = __importDefault(require("./models/Config"));
exports.Config = Config_1.default;
var Account_1 = __importDefault(require("./ocean/Account"));
exports.Account = Account_1.default;
var DID_1 = __importDefault(require("./ocean/DID"));
exports.DID = DID_1.default;
var Ocean_1 = require("./ocean/Ocean");
Object.defineProperty(exports, "Ocean", { enumerable: true, get: function () { return Ocean_1.Ocean; } });
var Logger_1 = require("./utils/Logger");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return Logger_1.LoggerInstance; } });
var Keeper_1 = __importDefault(require("./keeper/Keeper"));
exports.Keeper = Keeper_1.default;
var Aquarius_1 = require("./aquarius/Aquarius");
Object.defineProperty(exports, "Aquarius", { enumerable: true, get: function () { return Aquarius_1.Aquarius; } });
var templates = __importStar(require("./keeper/contracts/templates"));
exports.templates = templates;
var conditions = __importStar(require("./keeper/contracts/conditions"));
exports.conditions = conditions;
var utils = __importStar(require("./utils"));
exports.utils = utils;
__exportStar(require("./ddo/DDO"), exports);
__exportStar(require("./ddo/MetaData"), exports);
var OceanAssets_1 = require("./ocean/OceanAssets");
Object.defineProperty(exports, "CreateProgressStep", { enumerable: true, get: function () { return OceanAssets_1.CreateProgressStep; } });
var OceanCompute_1 = require("./ocean/OceanCompute");
Object.defineProperty(exports, "ComputeJobStatus", { enumerable: true, get: function () { return OceanCompute_1.ComputeJobStatus; } });
var ServiceUtils_1 = require("./ocean/utils/ServiceUtils");
Object.defineProperty(exports, "OrderProgressStep", { enumerable: true, get: function () { return ServiceUtils_1.OrderProgressStep; } });
var OceanVersions_1 = require("./ocean/OceanVersions");
Object.defineProperty(exports, "OceanPlatformTechStatus", { enumerable: true, get: function () { return OceanVersions_1.OceanPlatformTechStatus; } });
var conditions_1 = require("./keeper/contracts/conditions");
Object.defineProperty(exports, "Condition", { enumerable: true, get: function () { return conditions_1.Condition; } });
Object.defineProperty(exports, "ConditionState", { enumerable: true, get: function () { return conditions_1.ConditionState; } });
//# sourceMappingURL=squid.js.map